export const PAY_TYPE = {
  ALIPAY: 'alipay_pay_url',
  WECHAT: 'wechat_h5',
  COIN: 'gold_coin',
  PAYPAL: 'paypal',
  STRIPE: 'stripe',
  LARK: 'lark',
  GOOGLE_PAY: 'google_pay_url',
} as const;

export const payList = [
  {
    name: '支付宝',
    shortName: 'ZFB',
    value: PAY_TYPE.ALIPAY,
    theme: 'alipay',
  },
  {
    name: '微信',
    shortName: 'WX',
    value: PAY_TYPE.WECHAT,
    theme: 'wechat',
  },
  {
    name: 'PayPal',
    shortName: 'PP',
    value: PAY_TYPE.PAYPAL,
    theme: 'paypal',
  },
  {
    name: 'Stripe',
    shortName: 'ST',
    value: PAY_TYPE.STRIPE,
    theme: 'stripe',
  },
  {
    name: 'Lark',
    shortName: 'LK',
    value: PAY_TYPE.LARK,
    theme: 'lark',
  },
] as const;

export const currencyList = [
  { name: '美元', currency: 'USD', symbol: '$' },
  { name: '港币', currency: 'HKD', symbol: 'HK$' },
  { name: '台币', currency: 'TWD', symbol: 'NT$' },
  { name: '日元', currency: 'JPY', symbol: '¥' },
  { name: '英镑', currency: 'GBP', symbol: '£' },
  { name: '欧元', currency: 'EUR', symbol: '€' },
  { name: '澳元', currency: 'AUD', symbol: 'A$' },
  { name: '澳元', currency: 'AUDS', symbol: 'A$' },
  { name: '加拿大元', currency: 'CAD', symbol: 'C$' },
  { name: '巴西雷亚尔', currency: 'BRL', symbol: 'R$' },
  { name: '捷克克朗', currency: 'CZK', symbol: 'Kč' },
  { name: '丹麦克朗', currency: 'DKK', symbol: 'kr' },
  { name: '匈牙利福林', currency: 'HUF', symbol: 'Ft' },
  { name: '以色列新谢克尔', currency: 'ILS', symbol: '₪' },
  { name: '马来西亚林吉特', currency: 'MYR', symbol: 'RM' },
  { name: '墨西哥比索', currency: 'MXN', symbol: 'Mex$' },
  { name: '新西兰元', currency: 'NZD', symbol: 'NZ$' },
  { name: '挪威克朗', currency: 'NOK', symbol: 'kr' },
  { name: '菲律宾比索', currency: 'PHP', symbol: '₱' },
  { name: '波兰兹罗提', currency: 'PLN', symbol: 'zł' },
  { name: '俄罗斯卢布', currency: 'RUB', symbol: '₽' },
  { name: '新加坡元', currency: 'SGD', symbol: 'S$' },
  { name: '瑞典克朗', currency: 'SEK', symbol: 'kr' },
  { name: '瑞士法郎', currency: 'CHF', symbol: 'CHF' },
  { name: '泰铢', currency: 'THB', symbol: '฿' },
] as const;
